import {FormInterface} from "./Form.interface";
import {FormSchema} from "./Form.schema";
import {PromocodeInterface} from "@/views/Admin/Events/Event/Promocodes/Promocode/Promocode.interface";

export const normalizeForm = (
    raw: Record<string, any> = {},
    allGroups: any[] = []
): FormInterface => {
    const result: FormInterface = {
        isLoading: false,
        fields: {} as FormInterface['fields'],
    };

    const schemaFields = FormSchema.fields;

    for (const key in schemaFields) {
        const schemaField = schemaFields[key];
        const rawValue = raw?.[key];

        let value = rawValue !== undefined && rawValue !== null ? rawValue : schemaField.value;

        // Обработка числовых полей, где null Infinity
        if ((key === 'maxticket' || key === 'maxsum' || key === 'count') && rawValue === null) {
            value = Infinity;
        }

        result.fields[key] = {
            ...schemaField,
            value,
            isChanged: false,
        };
    }

    return result;
};


export const serializeFormValues = (
    form: FormInterface,
    isEditMode = false
): Record<string, any> => {
    const result: Record<string, any> = {};

    for (const key of Object.keys(FormSchema.fields)) {
        if (key === 'promocodes' || key === 'groupSuggestState') continue;

        const field = form.fields[key];
        if (isEditMode && !field?.isChanged) continue;

        let value = field?.value;

        switch (key) {
            case 'promocode':
                value = typeof value === 'object' && value !== null ? value.code : value;
                break;
            case 'minsum':
                if (value === 0) value = null;
                break;
            case 'minticket':
                if (value === 1) value = null;
                break;

            case 'groupId':
            case 'maxticket':
            case 'maxsum':
            case 'eventId':
            case 'size':
                if (value === '' || value === 'Infinity' || value === null) {
                    value = null;
                } else {
                    value = Number(value);
                    if (isNaN(value)) value = null;
                }
                break;

            case 'count':
                if (value === Infinity || value === 'Infinity' || value === '') {
                    value = 0;
                } else {
                    value = Number(value);
                    if (isNaN(value)) value = null;
                }
                break;

            case 'autoUse':
            case 'autoUseConsult':
            case 'useOptions':
            case 'isCertificate':
                value = Boolean(value);
                break;

            case 'from':
            case 'till':
                value = typeof value === 'string' && value !== '' ? value : null;
                break;

            default:
                value = value ?? null;
                break;
        }

        result[key] = value;
    }

    // если установлен лимит на кол-во использований
    result.count !== 0 ? result.unlimited = 0 : result.unlimited = 1

    return result;
};


export const normalizeBulkForm = (
    promocodes: PromocodeInterface[],
): FormInterface => {
    const result: FormInterface = {
        isLoading: false,
        fields: {} as FormInterface['fields'],
    };

    const keys = Object.keys(FormSchema.fields);

    for (const key of keys) {
        const schemaField = FormSchema.fields[key];
        const values = promocodes.map(p => p?.[key]);

        const allEqual = values.every(v => v === values[0]);
        let finalValue = allEqual ? values[0] : '—';

        if (key === 'minticket' && finalValue === null) {
            finalValue = 1;
        }

        if (key === 'minsum' && finalValue === null) {
            finalValue = 0;
        }
        // Обработка числовых полей, где null Infinity
        if ((key === 'maxsum' || key === 'maxticket' || key === 'count') && finalValue === null) {
            finalValue = Infinity;
        }

        result.fields[key] = {
            ...schemaField,
            value: finalValue,
            isChanged: false,
            error: null,
        };
    }
    return result;
};

